import { css } from "@emotion/core";

export const scrollToTopCss = css`
    bottom: 95px;
    right: 30px;
`;
